export default "__VITE_ASSET__Bd85fxhg__"